import Header from './Header.vue';

export default Header;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/remote-edu/components/top/components/header/index.ts